import axios from "axios";
import { API_URL } from "../config";

export const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true, // cookie’nin refresh endpointine gitmesi için
});

//axios yerine apiClient kullanacağız.Böylece tüm uygulama aynı kurallara uyacak.